import { FC, memo } from 'react';

import { FallbackedLayout } from '@/common/layouts';

import { useGetLayoutsPageQuery } from '@/modules/Pages/queries';
import { PageLayoutsOverviewView } from '@/modules/Pages/views/PageTemplates/PageLayouts/PageLayoutsOverview/PageLayoutsOverviewView';

interface Props {
  siteId: string;
}

export const PageLayoutsOverviewContainer: FC<Props> = memo(({ siteId }) => {
  const { data, isLoading, isError, error } = useGetLayoutsPageQuery(siteId)({
    enabled: !!siteId
  });

  return (
    <FallbackedLayout data={ data } error={ error } isError={ isError } isLoading={ isLoading }>
      {
        (layoutsList) => (
          <PageLayoutsOverviewView
            items={ layoutsList }
          />
        )
      }
    </FallbackedLayout>
  );
});
